<div
  *transloco="let t; prefix: 'predictive-breakdown-widgetette'"
  class="predictive-breakdown-widgetette__container"
>
  <div class="predictive-breakdown-widgetette__header">
    <span class="predictive-breakdown-widgetette__title">{{ t('breakdown') }}</span>

    <app-metric-settings-pill
      [predictiveOptions]="predictiveOptions"
      [isReadOnly]="isReadOnly"
      [isDashboardLocked]="isDashboardLocked"
      (settingsChange)="onMetricSettingsChange($event)"
    ></app-metric-settings-pill>
  </div>

  <app-breakdown-table
    [breakdowns]="breakdowns"
    [focusedBreakdown]="focusedBreakdown"
    [predictiveOptions]="predictiveOptions"
    [isReadOnly]="isReadOnly"
    [isDashboardLocked]="isDashboardLocked"
    [comparison]="comparison"
    (select)="onSelectBreakdown($event)"
    (hideBreakdown)="onHideBreakdown($event)"
    (resetBreakdownSimulation)="onResetBreakdownSimulation($event)"
  ></app-breakdown-table>
</div>
